import Script from 'next/script';
import { useEffect, useState } from 'react';
interface Props {
	containerId?: string;
}

export const Matomo = ({ containerId }: Props) => {
	const matomoTracking = `  
		var _mtm = window._mtm = window._mtm || [];
		_mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
		(function() {
			var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
			g.async=true; g.src='https://analytics.sullissivik.gl/js/container_${containerId}.js'; s.parentNode.insertBefore(g,s);
		})();
  	`;

	const [nonce, setNonce] = useState<string | null>(null);

	useEffect(() => {
		const meta = document.querySelector('meta[name="csp-nonce"]');
		if (meta) setNonce(meta.getAttribute('content'));
	}, [containerId]);

	if (!nonce) return null;
	return containerId ? (
		<Script strategy="afterInteractive" id="matomo" type="text/javascript" dangerouslySetInnerHTML={{ __html: matomoTracking }} nonce={nonce} />
	) : null;
};
